import React, { FC, useEffect, useState } from 'react'
import './EditDeliveryUltra.scss' 
import { useForm } from 'react-hook-form'; 
import { yupResolver } from '@hookform/resolvers/yup';  
import * as yup from 'yup'; 
import { ShowTGAlert } from '../../../../../Helpers/ShowTGAlert'; 
import deliveryService from '../../../../../Services/deliveryService';
 
    interface propsType {
        toggleEditModal: ()=>void,
        countries: Array<countryType>,
        editData?: {
            id: string;
            localGovernmentArea: string;
            deliveryFeeMajor: number;
            currency: string;
            createdAtISO8601: string;
            country: string|undefined;
            state: string|undefined;
        }
    }

    export type AddDeliveryFeeFormType = {  
        country: string,
        state: string,
        localGovernmentArea: string,
        deliveryFeeMajor: number 
    }

    export type countryType = {
        name: string,
        iso2: string,
        phoneCode: string,
        currency: string,
        currencySymbol: string,
        states: [
          {
            name: string,
            localGovernmentAreas: [ string ]
          }
        ]
    }

    export type stateType = {  
            name: string,
            localGovernmentAreas: [ string ] 
    }
  
  const schema = yup.object().shape({ 
    country: yup.string().required('country field is required'), 
    state: yup.string().required('state field is required'),
    localGovernmentArea: yup.string().required('LGA field is required'),
    deliveryFeeMajor: yup.number().required('Delivery Fee field is required'),
  });
  

const EditDeliveryUltra:FC<propsType> = ({toggleEditModal, editData}) => { 
  
   const {handleSubmit, setValue, register, formState:{errors}} = useForm<AddDeliveryFeeFormType>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()  
  const [request, setRequest] = useState(false) 

  const submitNewUserInformation = handleSubmit(async (data:AddDeliveryFeeFormType) => { 
    setRequest(true)  
    await deliveryService.createNewDelivery(data).then(()=>{
        setRequest(false)  
        toggleEditModal()

        showAlert({message: 'Delivery fee updated successfully', show:true, title: 'Success', type: 'success'}) 

        setTimeout(()=>{ 
            window.location.reload()
        }, 2000)

    }, (error: { response: { data: { error: string } } }) =>{ 

        setRequest(false)   
        toggleEditModal()  
        showAlert({message: error.response.data.error, show:true, title: 'Error', type: 'error'}) 
   }) 
  }); 

  
    useEffect(()=>{
        if(editData && editData.country && editData.state){
            setValue('country', editData?.country)
            setValue('deliveryFeeMajor', editData?.deliveryFeeMajor)
            setValue('localGovernmentArea', editData?.localGovernmentArea)
            setValue('state', editData?.state) 
        }
    }, [editData])
    return (
        <div className='AddUser'> 
             <form action='/product-scanner'>
                <div className='form-group mb-3'>
                    <label htmlFor="price-per-lit">Delivery Fee</label>
                    <input type="text" id="newCustomerFirstName" className='form-control' {...register('deliveryFeeMajor')}/>
                    {errors.deliveryFeeMajor && <div className='text-danger'>{errors.deliveryFeeMajor.message}</div>}
                </div>
                <div className='form-group mb-3'>
                    <label htmlFor="price-per-lit">Country</label>
                    <input  type="text"  id="newCustomerLastName" className='form-control' {...register('country')} readOnly/>
                    {errors.country && <div className='text-danger'>{errors.country.message}</div>}
                </div>  
                  <div className='form-group mb-3'>
                    <label htmlFor="price-per-lit">State </label>
                    <input  type="text" id="newCustomerLastName" className='form-control' {...register('state')} readOnly/> 
                    {errors.state && <div className='text-danger'>{errors.state.message}</div>}
                </div>  
                <div className='form-group mb-3'>
                    <label htmlFor="price-per-lit">LGA </label>
                    <input  type="text" id="newCustomerLastName" className='form-control' {...register('localGovernmentArea')} readOnly/> 
                    {errors.localGovernmentArea && <div className='text-danger'>{errors.localGovernmentArea.message}</div>}
                </div>  
                <div className='form-group mb-3'>
                    <button className='btn btn-default w-100' onClick={(e) => submitNewUserInformation(e)} disabled={request}>Save Fee {request && <span className='spinner-border spinner-border-sm'></span>}</button> 
                </div> 
            </form>
        </div>
    )
}

export default EditDeliveryUltra
